import { Component, OnInit, ViewChild } from '@angular/core';
import { HistoricoEventoService } from '../../../../../services/database/historico-evento.service';
import { TranslateService } from '@ngx-translate/core';
import { CustomTableComponent, CustomTitle, DataColumnType, ICustomTable } from 'lib-base';
import { firstValueFrom, forkJoin } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import { TabViewModule } from 'primeng/tabview';
import { ICategorizacionTramiteHistorico } from '../../../../../shared/interfaces/database/configuracion';

@Component({
  selector: 'app-admin-categorizaciones-historico',
  standalone: true,
  imports: [CustomTableComponent, DialogModule, CustomTitle, TabViewModule],
  templateUrl: './admin-categorizaciones-historico.component.html',
  styleUrl: './admin-categorizaciones-historico.component.scss'
})
export class AdminCategorizacionesHistoricoComponent implements OnInit {
  title: string = 'msg:Categorizacion Historial';
  displayModal: boolean = false;
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;

  constructor(private _hes: HistoricoEventoService, private _t: TranslateService) { }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      categorizacion: this._t.get('common.categorizacion'),
      usuarioEvento: this._t.get('common.usuarioEvento'),
      evento: this._t.get('common.evento'),
      fechaActualizacion: this._t.get('common.fechaActualizacion'),
      categorizacionHistorial: this._t.get('msg.categorizacionHistorial')
    }));
    this.title = this.trans.categorizacionHistorial
    this.configColumns();
  }

  private configColumns() {
    this.customTable = {
      columns: [
        {
          field: 'descripcion',
          header: this.trans.categorizacion,
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'usuarioEvento',
          header: this.trans.usuarioEvento,
          width: '5rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'evento',
          header: this.trans.evento,
          width: '5rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaActualizacion',
          header: this.trans.fechaActualizacion,
          width: '5rem',
          dataType: DataColumnType.DATE
        },
      ]
    } as ICustomTable;
  }

  show(hojaDeVidaTramiteId: number) {
    this.displayModal = true;
    this.loadHistorial(hojaDeVidaTramiteId);
  }

  showEliminado() {
    this.displayModal = true;
    this.loadHistorialEliminado();
  }

  hide() {
    this.displayModal = false;
  }

  loadHistorial(hojaDeVidaTramiteId: number) {
    this._hes.getCategorizacionTramiteHistorico(hojaDeVidaTramiteId).subscribe({
      next: (data: ICategorizacionTramiteHistorico[]) => {
        this.customTableComponent.data = data;
      }
    });
  }

  loadHistorialEliminado() {
    this._hes.getCategorizacionTramiteHistoricoEliminado().subscribe({
      next: (data: ICategorizacionTramiteHistorico[]) => {
        this.customTableComponent.data = data;
      }
    });
  }
}
